module.exports = __webpack_public_path__ + "img/sc5_003.3a6bb2dd.png";